import React from 'react';
import DrawerBox from './drawer-content';
import Calculator from './calculator';

interface IProps {
    visible: boolean;
    closed: () => void;
}

const Index = (props: IProps) => {
    return (
        <DrawerBox wrapClassName="sub-tiku__calc-self" closed={() => props.closed()} visible={props.visible}>
            <Calculator />
        </DrawerBox>
    );
};

export default Index;
